import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- //
import { LocalSEO } from 'components/blocks/portfolio';
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords'; 
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Brighton Boxes',
  categories: 'seo, web design',
  description:
    'Brighton Boxes is a local business that sells boxes and packaging materials. We were asked to design, develop and promote a new website for them. Our SEO strategy has helped them to rank in the top 3 for their main keywords.',
  parentDirectories: 'seo-design-portfolio'
};
const Portfolio = All.LocalSEOArrays[3].keywords;
const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
urlENPT={``}
url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative lightblue" style={{ maxHeight: 500 }}>
          <div className="h-min-100vh h-md-auto color w-100"></div>
          <div className="container gx-0 text-center mt-n10 wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden h-min-100vh h-md-auto d-flex align-items-center">
            <div className="h-100 w-100 hero-portfolio position-absolute left-0">
              <img
                className="w-100 object-fit-cover w-min-100"
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
                style={{ maxHeight: 560, height: '90%' }}
              />
              <div></div>
            </div>
            {/* <div className="row mx-auto">
              <div className="col-md-12 mx-auto text-center">
                <div className="post-header mx-auto text-center">
                 

                  <h1 className="fs-15 text-uppercase text-white mb-3">- {Portfolio[0].title} -</h1>
                  <p className="display-4 text-capitalize">{details.pageName}</p>
                </div>
              </div>
            </div> */}
          </div>
        </section>
        {/* ========== details section ========== */}
        <section className="wrapper bg-light wrapper-border">
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className={titleClass}>{Portfolio[0].title}</h2>

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-md-9 text-justify order-0 pe-10">
                    <h2 className="display-6 mb-4">{details.pageName}</h2>
                    <p>
                      <strong className="caption">{details.description}</strong>
                    </p>{' '}
                    <div className="position-relative">
                      <img
                        width={120}
                        height={120}
                        src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                        alt={All.localSEOPackages[1].title}
                        style={{ background: 'transparent' }}
                        className="mb-5 me-3"
                      />{' '}
                      <img
                        width={'100%'}
                        height={'auto'}
                        src={`/img/clients/page-1-google.jpg`}
                        alt={`Google Search Results Page 1`}
                        style={{ background: 'transparent' }}
                        className="mb-10 mw"
                      />
                    </div>
                    <h3>{Portfolio[0].title}</h3>
                    <p>
                      Brighton Boxes is a leading provider of packing boxes in Brighton. At SEOptimist Digital Marketing
                      Agency Brighton, we understand the importance of delivering measurable results through effective
                      digital marketing strategies. We're proud to have helped Brighton Boxes achieve significant
                      success with their online presence, and we're excited to share our success story with you.
                    </p>
                    <h3>{Portfolio[1].title}</h3>
                    <p>
                      As a digital agency Brighton, our team knew that we needed to create a comprehensive digital
                      marketing strategy that would help Brighton Boxes increase their online visibility and attract
                      more traffic to their website. Our first step was to conduct extensive keyword research to
                      identify the most relevant keywords that Brighton Boxes' target audience was searching for.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[2].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 mw"
                    />
                    <h3>{Portfolio[2].title}</h3>
                    <p>
                      Once SEOptimist <NextLink title={All.HomeList[0].title} href="/" /> had identified the target keywords,
                      we implemented a robust SEO strategy to help Brighton Boxes achieve number 1 results for their
                      desired keywords in Google. We optimized their website's content and structure, implemented
                      on-page optimization techniques, and created high-quality content that was optimized for search
                      engines and user experience.
                    </p>
                    <p>
                      Through our ongoing SEO efforts, we were able to help Brighton Boxes achieve their desired results
                      in Google. Their website now ranks number 1 for their desired keywords, driving more traffic to
                      their website and improving engagement.
                    </p>
                    <p>
                      But our digital marketing efforts didn't stop there. We also implemented a comprehensive content
                      marketing strategy, creating high-quality blog posts and social media content that provided value
                      to Brighton Boxes' target audience. This content helped establish Brighton Boxes as an authority
                      in their field and generated leads and sales.
                    </p>
                    <p>
                      As a digital marketing agency in Brighton, we understand the unique challenges that businesses in
                      Brighton face when it comes to digital marketing. That's why SEOptimist{' '}
                      <NextLink title={All.HomeList[1].title} href="/" /> offer customized solutions to help businesses
                      achieve their online goals. Contact us today to learn more about our digital marketing Brighton
                      services and how we can help your business achieve success online.
                    </p>{' '}
                    <p></p>
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                  </div>

                  <div className="col-md-3 ms-auto order-1 pt-10">
                    <ul className="list-unstyled mb-10">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                    <img
                      width={250}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10"
                    />
                  </div>
                </div>
              </div>
            </div>
            <LocalSEO initialslide={0} />
          </div>
        </section>

        <ProjectDetailsNavigation />
        </main>

        <ContactFooterCombo location="brighton" />
    </Fragment>
  );
};

export default ProjectDetails;
